import { ScheduleService } from '@/openapi';
import { useQuery } from '@tanstack/react-query';
import { emdash } from '@/util/unicode';
import { queryKeys } from '@/util/queryKeys';

export const usePartnerScheduleQuery = (
  profileId: number | undefined,
  fromDate: string,
  toDate: string
) =>
  useQuery({
    queryKey: queryKeys.schedule.byDate(fromDate, toDate, false),
    queryFn: async () => {
      // it's possible to not have a profileId, in which case this query is disabled below
      const schedule = await ScheduleService.scheduleServiceGetPartnerSchedule({
        path: {
          partnerId: profileId ?? 0,
        },
        query: {
          fromDate,
          toDate,
        },
      });
      const assignments: Record<string, string> = {};
      schedule.data.dates.forEach((workday) => {
        if (workday.date) {
          assignments[workday.date] = workday.symbol ?? emdash;
        }
      });

      return assignments;
    },
    enabled: !!profileId,
  });
